// extracted by mini-css-extract-plugin
module.exports = {"app__wrapper":"app_app__wrapper__4WNDA","appHeader":"app_appHeader__3UFa_","content__wrapper":"app_content__wrapper__1WrG3","emptyText":"app_emptyText__obGNU"};